import { buildSelector } from '@/shared/lib/store';

export const [useGetTradingPlatformSessionType] = buildSelector(
    (state) => state.tradingPlatformSession.connectionType,
);
